import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { Link } from 'react-router-dom'
import { Icon } from 'loyal-react'

const Breadcrumb = ({ breadcrumb }) => {
  return (
    <div className='container-fluid'>
      <div className='container'>
        <div className='row' id='breadcrumb'>
          <div className='col-12'>
            <ol aria-label='breadcrumb'>
              <li>
                <Link className='home-breadcrumb txt-font-body' to='/'>
                  <Icon iconName='icon_home' className='icon-sm' />
                  Início
                </Link>
              </li>
              {breadcrumb.paths.map(({ url, description, current }) => (
                current
                  ? (<Fragment>
                    <span aria-hidden='true' className='breadcrumb-separator txt-font-body'>/</span>
                    <li className='current-page-breadcrumb'>
                      {description}
                    </li>
                  </Fragment>)
                  : (<Fragment>
                    <span aria-hidden='true' className='breadcrumb-separator txt-font-body'>/</span>
                    <li key={url}>
                      <Link className='home-breadcrumb txt-font-body' to={url}>
                        {description}
                      </Link>
                    </li>
                  </Fragment>)
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>)
}

Breadcrumb.propTypes = {
  breadcrumb: PropTypes.array
}

const mapStateToProps = ({ breadcrumb }) => ({ breadcrumb })

export default connect(
  mapStateToProps,
  null
)(Breadcrumb)



// WEBPACK FOOTER //
// ./src/App/Breadcrumb/Breadcrumb.js